import api from 'service/api'
import { getBaseURL } from 'service/env'

const dponetAPI = api.create('dponet', false)
const baseURL = getBaseURL('dponet')

const show = async ({ incidentId }) => {
  return await dponetAPI.get(
    `/incidents/${incidentId}/communication_incident_emails/show`,
  )
}

const upload = async ({ incidentId, ...data }) => {
  return await dponetAPI.postForm(
    `${baseURL}/incidents/${incidentId}/communication_incident_emails/attachments`,
    data,
  )
}

export default { show, upload }
